import Toast from './Toast';

/**
 * Copie l'URL complète (origine + chemin) dans le presse-papier et affiche
 * une confirmation. Utilisé pour partager rapidement le lien d'un dossier
 * ou d'une tâche depuis son code (QuickView / page de détails).
 */
export function copyLinkToClipboard(path, label = 'Lien') {
  const url = `${window.location.origin}${path}`;
  navigator.clipboard?.writeText(url)
    .then(() => Toast.success(`${label} copié dans le presse-papier.`))
    .catch(() => Toast.error('Impossible de copier le lien.'));
}
